(function () {
  const containers = document.querySelectorAll('[data-breadcrumb-container]');

  containers.forEach(initBreadcrumb);

  function initBreadcrumb(container) {
    const list = container.querySelector('[data-breadcrumb-list]');
    const expandBtn = container.querySelector('[data-breadcrumb-expand]');
    const middleItems = container.querySelectorAll('[data-crumb-middle]');

    if (!list || middleItems.length === 0) return;

    let expanded = false;

    function condense() {
      if (expanded) return;

      container.removeAttribute('data-breadcrumb-condensed');
      middleItems.forEach((item) => item.removeAttribute('data-crumb-hidden'));

      requestAnimationFrame(() => {
        if (list.scrollWidth > list.clientWidth + 1) {
          for (let i = 0; i < middleItems.length; i++) {
            middleItems[i].setAttribute('data-crumb-hidden', '');
          }
          container.setAttribute('data-breadcrumb-condensed', '');
        }
      });
    }

    function expand() {
      expanded = true;
      container.removeAttribute('data-breadcrumb-condensed');
      container.setAttribute('data-breadcrumb-expanded', '');
      middleItems.forEach((item) => item.removeAttribute('data-crumb-hidden'));
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', expand);
    }

    const ro = new ResizeObserver(() => {
      if (!expanded) condense();
    });
    ro.observe(container);

    condense();
  }
})();
